import React from "react";
import useBranding from "../../hooks/useBranding";
import PrivacyPolicySrds from "./PrivacyPolicy.srds.jsx";
import PrivacyPolicyProschool from "./PrivacyPolicy.proschool.jsx";

/**
 * Privacy Policy wrapper.
 * Picks the variant based on current brand.
 * SRDS is the default fallback.
 */
const PrivacyPolicy = () => {
  const branding = useBranding();

  if (branding.variant === "proschool") {
    return <PrivacyPolicyProschool />;
  }
  return <PrivacyPolicySrds />;
};

export default PrivacyPolicy;
